import { Context, Logger } from '@vue-storefront/core';
import { isAxiosError } from 'axios';

import { IUseInvoicesRefs } from '../types';
import { Pagination } from '@api-client/src/api/getInvoices/types';

const getInvoices =
  (context: Context, refs: IUseInvoicesRefs) =>
  async (customerId: string, pagination?: Pagination) => {
    Logger.debug(`useInvoice/getInvoices`);

    refs.result.value = null;
    refs.error.value = null;
    try {
      refs.loading.value = true;
      refs.result.value = await context.$xero.api.getInvoices(customerId, pagination);
      refs.error.value = null;
    } catch (error) {
      if (isAxiosError(error)) {
        refs.error.value = error.response?.data;
      } else {
        refs.error.value = error as Error;
      }
      Logger.error(`useInvoice/getInvoices/error`, error);
    } finally {
      refs.loading.value = false;
    }
  };

export default getInvoices;
